export default "__VITE_ASSET__0123741d__"